/**
 * Two-Factor Authentication Code Input Handler
 */
export function initTwoFactorAuth() {
  const inputs = document.querySelectorAll(".code-digit");
  if (!inputs.length) return; // Exit if not on 2FA page

  const hidden = document.getElementById("two_factor_code");
  const form = document.getElementById("twoFactorForm");

  function updateHidden() {
    let code = "";
    inputs.forEach((inp) => {
      code += inp.value || "";
    });
    hidden.value = code;
  }

  function focusNext(currentIndex) {
    if (currentIndex < inputs.length - 1) {
      inputs[currentIndex + 1].focus();
    }
  }

  function focusPrev(currentIndex) {
    if (currentIndex > 0) {
      inputs[currentIndex - 1].focus();
    }
  }

  function getAllFilled() {
    return Array.from(inputs).every((inp) => inp.value.length === 1);
  }

  inputs.forEach((input, index) => {
    // Handle numeric input
    input.addEventListener("input", (e) => {
      if (e.target.value.length === 1 && /^\d$/.test(e.target.value)) {
        focusNext(index);
      }
      updateHidden();
    });

    // Handle backspace navigation
    input.addEventListener("keydown", (e) => {
      if (e.key === "Backspace" && !e.target.value) {
        e.preventDefault();
        focusPrev(index);
      }
    });

    // Handle paste
    input.addEventListener("paste", (e) => {
      e.preventDefault();
      const paste = (e.clipboardData || window.clipboardData).getData("text");
      const digits = paste.replace(/\D/g, "");

      for (let i = 0; i < Math.min(digits.length, inputs.length - index); i++) {
        inputs[index + i].value = digits[i];
      }

      updateHidden();
    });
  });

  // Focus first input
  inputs[0]?.focus();
}

function disableSubmitButtons(form) {
  if (!form) return;
  const buttons = form.querySelectorAll(
    "button[type='submit'], input[type='submit']",
  );
  buttons.forEach((button) => {
    const loadingText =
      button.getAttribute("data-loading-text") || "Enviando...";
    if (button.tagName.toLowerCase() === "button") {
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent || "";
      }
      button.textContent = loadingText;
    } else if (button.tagName.toLowerCase() === "input") {
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.value || "";
      }
      button.value = loadingText;
    }
    button.disabled = true;
    button.setAttribute("aria-disabled", "true");
    button.classList.add("opacity-70", "cursor-not-allowed");
  });
}

export function initFormSubmitDisable() {
  const forms = document.querySelectorAll(".login-content form");
  if (!forms.length) return;

  forms.forEach((form) => {
    form.addEventListener("submit", (event) => {
      if (form.dataset.submitting === "true") {
        event.preventDefault();
        return;
      }

      form.dataset.submitting = "true";
      disableSubmitButtons(form);
    });
  });
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initTwoFactorAuth();
    initFormSubmitDisable();
  });
} else {
  initTwoFactorAuth();
  initFormSubmitDisable();
}
